export default __webpack_public_path__ + "static/media/diagram-DNS.fbe6d3f7.png";